<mat-dialog-content>
  <div>
    <img src="{{imgSrclUrl}}" alt="image at full size">
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>